import { Builder } from '@builder.io/react'
import { HeroImage } from './HeroImage'

Builder.registerComponent(HeroImage, {
  name: 'Hero Image',
  inputs: [
    {
      name: 'heroTitle',
      type: 'string',
      defaultValue: 'Choose Your Adventure',
    },
    {
      name: 'heroDescription',
      type: 'string',
      defaultValue: 'Turn dreams into memories with our kits.',
    },
    {
      name: 'videoSrc',
      type: 'string',
      defaultValue:
        'https://cdn.builder.io/o/assets%2F86c411b0ae7d404c8cdfbc782a799149%2F2887bbf03257440e9b2696dff3044c19%2Fcompressed?apiKey=86c411b0ae7d404c8cdfbc782a799149&token=2887bbf03257440e9b2696dff3044c19&alt=media&optimized=true',
    },
    {
      name: 'heroImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png'],
      required: true,
      defaultValue:
        'https://cdn.builder.io/api/v1/image/assets%2F86c411b0ae7d404c8cdfbc782a799149%2F7a22281d6a514a888463b7f381800a77',
    },
    {
      name: 'heroImageAlt',
      type: 'string',
      defaultValue: `New Way Van Life Website Header Image or Video.`,
    },
    {
      name: 'featuredTextOne',
      type: 'string',
      defaultValue: `Full Service Sprinter Builds`,
    },
    {
      name: 'featuredLinkOne',
      type: 'string',
      defaultValue: `/Interior-conversion`,
    },
    {
      name: 'featuredButtonTextOne',
      type: 'string',
      defaultValue: `Learn more`,
    },
    {
      name: 'featuredTextTwo',
      type: 'string',
      defaultValue: `Modular DIY Kits & Parts`,
    },
    {
      name: 'featuredLinkTwo',
      type: 'string',
      defaultValue: `/collection/shop-all`,
    },
    {
      name: 'featuredButtonTextTwo',
      type: 'string',
      defaultValue: `Shop`,
    },
  ],
})
